import { render, staticRenderFns } from "./PricingHistoryEntry.vue?vue&type=template&id=36c82b51&"
import script from "./PricingHistoryEntry.vue?vue&type=script&lang=ts&"
export * from "./PricingHistoryEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports